import { createContext, useContext, useMemo } from 'react';

import { featureFlagKeys } from 'modules/common/drawers/featureFlagDrawer/const/featureFlagKeys';

import { useFeatureFlagValue } from 'store/session/hooks';

type MarkInaccurateActionData = {
  isEnhancedPartbotEnabled: boolean;
};

const DEFAULT_ACTION_DATA: MarkInaccurateActionData = {
  isEnhancedPartbotEnabled: false,
};

const MarkInaccurateActionDataContext =
  createContext<MarkInaccurateActionData>(DEFAULT_ACTION_DATA);

type MarkInaccurateActionDataProviderProps = {
  children: React.ReactNode;
};

export const MarkInaccurateActionDataProvider = ({
  children,
}: MarkInaccurateActionDataProviderProps) => {
  const isEnhancedPartbotEnabled = useFeatureFlagValue(
    featureFlagKeys.isEnhancedPartbotEnabled,
  );

  const value = useMemo<MarkInaccurateActionData>(
    () => ({
      isEnhancedPartbotEnabled,
    }),
    [isEnhancedPartbotEnabled],
  );

  return (
    <MarkInaccurateActionDataContext.Provider value={value}>
      {children}
    </MarkInaccurateActionDataContext.Provider>
  );
};

export const useMarkInaccurateActionData = (): MarkInaccurateActionData =>
  useContext(MarkInaccurateActionDataContext);
